import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCheckmark1Medium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCheckmark1Medium"><Path d="M19.3965 6.77637L10.1699 19.5146L4.58594 14.1826L5.96777 12.7363L9.89355 16.4854L17.7764 5.60352L19.3965 6.77637Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCheckmark1Medium;
